<kendo-dialog-titlebar>
    <span> {{'global.editHelpText' | translate}}</span>
</kendo-dialog-titlebar>

<form *ngIf="!!helpText" [formGroup]="helpTextForm">
    <div>
         <app-html-editor-input-ctrl [caption]="'claims-center.claimMessages.contentText'" [formControlName]="'description'"
        [settings]="{fxFill:true,rows:200}" [extendedVersion]="true"></app-html-editor-input-ctrl>
    </div>
   
</form>

<kendo-dialog-actions>
    <button kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
    <button kendoButton (click)="confirm()" [primary]="true" submit>
        <span>{{'global.save' | translate}}</span>
    </button>
</kendo-dialog-actions>